<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Zmiana danych osobowych'" [name]="'Lista'"></app-breadcrumb>
<div class="change-data-list-container">
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="change-data-list-filters">
      <app-dict-ofwcas
        [multiple]="false" label="OFWCA"
        class="change-data-list-filter"
        [(ngModel)]="initialFilters.ofwca" name="ofwca"
      ></app-dict-ofwcas>

      <app-datepicker
        class="change-data-list-filter"
        label="Data zgłoszenia od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$dateOfSubmission" name="gte$dateOfSubmission"
      ></app-datepicker>

      <app-datepicker
        class="change-data-list-filter"
        label="Data zgłoszenia do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$dateOfSubmission" name="lte$dateOfSubmission"
      ></app-datepicker>

      <mat-form-field appearance="standard" class="change-data-list-filter">
        <mat-label>Dokumenty dostarczone</mat-label>
        <mat-select [(ngModel)]="initialFilters.documentsDelivered" name="documentsDelivered">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <app-dict-regionals
        [noneEntry]="true" [multiple]="true"
        [label]="'Regionalny (majątek)'"
        class="change-data-list-filter"
        [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
      ></app-dict-regionals>

      <app-dict-insurance-companies
        class="change-data-list-filter" [multiple]="true" label="TU"
        [required]="false"
        [(ngModel)]="initialFilters.in$insuranceCompany" name="in$insuranceCompany"
      ></app-dict-insurance-companies>

      <app-dict
        *ngIf="filterStatus"
        [multiple]="false" label="Status"
        class="change-data-list-filter"
        dictType="personal_data_change_status"
        [(ngModel)]="initialFilters.status" name="status"
      ></app-dict>
    </form>
  <div class="change-data-list-buttons">
    <button *ngIf="(userPermissions | async).personal_data_change.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).document.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="personalDataChanges" matSort>

    <ng-container matColumnDef="ofwcaFullName">
      <th mat-header-cell *matHeaderCellDef> Imię i nazwisko OFWCA</th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element?.ofwca?.fullName" class="default-link" [routerLink]="['/zmiana-danych-osobowych/szczegoly', element.uuid]">{{element?.ofwca?.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
            <td mat-cell *matCellDef="let element">
              <a *ngIf="element?.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">{{element.insuranceCompany.name}}</a>
            </td>
    </ng-container>

    <ng-container matColumnDef="dateOfSubmission">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="dateOfSubmission"> Data zgłoszenia </th>
            <td mat-cell *matCellDef="let element">
              {{element?.dateOfSubmission | date:'y-MM-dd'}}
            </td>
    </ng-container>

    <ng-container matColumnDef="documentsDelivered">
      <th mat-header-cell *matHeaderCellDef> Dokumenty dostarczone </th>
            <td mat-cell *matCellDef="let element">
              {{element?.documentsDelivered ? 'Tak' : 'Nie'}}
            </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) </th>
            <td mat-cell *matCellDef="let element">
              {{element?.ofwca?.assetsRegional?.firstName}} {{element?.ofwca?.assetsRegional?.lastName}}
            </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
